import { useState, useContext, useCallback, useEffect } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import DevExtremeDataGrid from 'devextreme/ui/data_grid';
import { withAppProvider } from "~/app-provider";
import { CallLogLookupsProvider } from '~/call-log-lookups-context';
import { AppContext } from "~/app-context";
import { appConst } from '~/app-const';
import { appNavigation } from '~/app-navigation';
import { appRoutes } from '~/app-routes';
import { LoginForm } from '~/components';
import {
  SideNavOuterToolbar as SideNavBarLayout,
  SingleCard
} from '~/layouts';
import { sizes } from '~/utils/media-query';
import { debounce } from '~/utils/debounce';
import 'devextreme/dist/css/dx.common.css';
import '~/themes/generated/theme.base.css';
import '~/themes/generated/theme.additional.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '~/app.scss';
import '~/dx-styles.scss';

//DevExtremeDataGrid.registerModule("columnChooserSorting", {
//    extenders: {
//        controllers: {
//            columns: {
//                getChooserColumns: function (loadAllColumns) {
//                    var result = this.callBase(loadAllColumns);
//                    result.sort(function (column1, column2) {
//                        return column1.caption.localeCompare(column2.caption);
//                    });
//                    return result;
//                }
//            }
//        }
//    }
//});

const LoginContainer = ({ logIn }) => <LoginForm onLoginClick={logIn} />;

const NotAuthPage = (props) => (
  <SingleCard>
    <Routes>
      <Route path="*" element={<LoginContainer {...props} />} />
    </Routes>
  </SingleCard>

);

const AuthPage = (props) => (
  <SideNavBarLayout menuItems={appNavigation} title={appConst.appName + " v" + appConst.release} {...props}>
    <Routes>
      {appRoutes.map(item => (
        <Route
          key={item.path}
          path={item.path}
          element={item.element}
        />
      ))}
      <Route path="/" element={<Navigate to="/home" replace />} />
    </Routes>
  </SideNavBarLayout>
);

const AppFunction = () => {
  const context = useContext(AppContext);
  const { loggedIn } = context;
  const getScreenSizeClass = useCallback(() => {

  const screenSizes = sizes();
    return Object.keys(screenSizes).filter(cl => screenSizes[cl]).join(' ');
  }, []);

  const [screenSizeClass, setScreenSizeClass] = useState(getScreenSizeClass());
  const [contextReady, setContextReady] = useState(false);

  const screenSizeChanged = useCallback(() => {
    setScreenSizeClass(getScreenSizeClass());
  }, [getScreenSizeClass]);

  useEffect(() => {
    const debouncedScreenResize = debounce(screenSizeChanged, 100);
    window.addEventListener('resize', debouncedScreenResize);
    return () => {
      window.removeEventListener('resize', debouncedScreenResize);
      debouncedScreenResize.cancel();
    };
  }, [screenSizeChanged]);

  useEffect(() => {
    if (context && context.loggedIn !== undefined && context.loggedIn!==null) {
      setContextReady(true);
    }
  }, [context]);

  const logIn = () => {
    context.onSignIn(true);
  }

  const logOut = () => {
    context.onSignOut();
  }

  const userMenuItems = [
    {
      text: 'Profile',
      icon: 'user'
    },
    {
      text: 'Logout',
      icon: 'runner',
      onClick: logOut
    }
  ];

  return (
    contextReady && <div className={`app ${screenSizeClass}`}>
      <Router>
        {loggedIn ? <CallLogLookupsProvider><AuthPage userMenuItems={userMenuItems} /></CallLogLookupsProvider> : <NotAuthPage logIn={logIn} />}
      </Router>
    </div>
  )
}

//class AppClass extends Component {
//  static contextType = AppContext;
//  constructor(props) {
//    super(props);
//    this.state = {
//      screenSizeClass: this.getScreenSizeClass(),
//      contextReady: false,
//    };
//    this.userMenuItems = [
//      {
//        text: 'Profile',
//        icon: 'user'
//      },
//      {
//        text: 'Logout',
//        icon: 'runner',
//        onClick: this.logOut
//      }
//    ];
//  }

//  componentDidMount() {
//    subscribe(this.screenSizeChanged);
//    if (this.context && this.context.loggedIn !== undefined && this.context.loggedIn !== null) {
//      this.setState({ contextReady: true });
//    }
//  }

//  componentWillUnmount() {
//    unsubscribe(this.screenSizeChanged);
//  }

//  render() {
//    const { loggedIn } = this.context;
//    const { contextReady } = this.state;

//    if (!contextReady) {
//      return <div>Loading...</div>
//    }

//    return (
//      <div className={`app ${this.state.screenSizeClass}`}>
//        <Router>
//          {loggedIn ? <AuthPage userMenuItems={this.userMenuItems} /> : <NotAuthPage logIn={this.logIn} />}
//        </Router>
//      </div>
//    );
//  }

//  getScreenSizeClass() {
//    const screenSizes = sizes();
//    return Object.keys(screenSizes).filter(cl => screenSizes[cl]).join(' ');
//  }

//  screenSizeChanged = () => {
//    this.setState({
//      screenSizeClass: this.getScreenSizeClass()
//    });
//  }

//  logIn = () => {
//    this.context.onSignIn(true);
//  };

//  logOut = () => {
//    this.context.onSignOut();
//  };
//}

const AppContainer = withAppProvider(AppFunction);

export const App = () => <AppContainer />;

